export const RESOURCE_COLOR_POOL = [
  '#FFB300',
  '#803E75',
  '#FF6800',
  '#A6BDD7',
  '#C10020',
  '#CEA262',
  '#817066',
  '#007D34',
  '#F6768E',
  '#00538A',
  '#FF7A5C',
  '#53377A',
  '#FF8E00',
  '#B32851',
  '#F4C800',
  '#7F180D',
  '#93AA00',
  '#593315',
  '#F13A13',
  '#00A6D6',
];

const toComparable = value => (value == null ? '' : String(value));

/**
 * Assigns a deterministic (but re-computable) color to each resource in a list.
 * The mapping is stable as long as the same resources are present (by id/name).
 * If the resource list changes (add/remove/rename), colors may be re-assigned.
 */
export function createResourceColorById(resources, colorPool = RESOURCE_COLOR_POOL) {
  const items = Array.isArray(resources) ? resources : [];
  const pool = Array.isArray(colorPool) && colorPool.length > 0 ? colorPool : RESOURCE_COLOR_POOL;

  const sorted = [...items].sort((a, b) => {
    const aName = toComparable(a?.name);
    const bName = toComparable(b?.name);
    if (aName !== bName) return aName.localeCompare(bName);
    const aId = toComparable(a?._id ?? a?.id);
    const bId = toComparable(b?._id ?? b?.id);
    return aId.localeCompare(bId);
  });

  const map = new Map();
  let nextIndex = 0;

  for (const res of sorted) {
    const id = toComparable(res?._id ?? res?.id);
    if (!id || map.has(id)) continue;

    const provided = toComparable(res?.color);
    if (provided) {
      map.set(id, provided);
      continue;
    }

    map.set(id, pool[nextIndex % pool.length]);
    nextIndex += 1;
  }

  return map;
}

